/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateCountryRequestViewModel } from "../types/UpdateCountryRequestViewModel.ts";

export const updateCountryRequestViewModelSchema = z.object({
  code: z.string().nullish(),
  name: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<UpdateCountryRequestViewModel>;
